import React from 'react';
import {NavLink} from "react-router-dom";
import style from '../LoginRequired/LoginRequired.module.css';

const NotFound = () => (
    <div className={style.wrap}>
        <div className={style.card}>
            <div className={style.icon} aria-hidden="true">?</div>
            <h1 className={style.title}>Страница не найдена</h1>
            <p className={style.text}>
                Возможно, ссылка устарела или в адресе опечатка. Попробуйте найти нужное через поиск на главной.
            </p>
            <NavLink className={style.button} to="/">На главную</NavLink>
        </div>
    </div>
);

export default NotFound;
